
import state from './allActivitiesState.js'
import * as mutations from './allActivitiesMutations.js'
import * as actions from './allActivitiesActions.js'
import * as getters from './allActivitiesGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}